import { createSlice } from "@reduxjs/toolkit";

import { get, patch, post } from "../helpers/axios";
import { POST_RESEND_OTP, POST_SIGN_UP } from "../helpers/url_helpers";

const initialState = {
  loading: false,
  signUpData: {},
  signUpError: "",
};

const signUp = createSlice({
  name: "signUp",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload.loading;
    },
    setSignupData: (state, action) => {
      state.signUpData = action.payload.signUpData;
    },
    setError: (state, action) => {
      state.signUpError = action.payload.signUpError;
    },
  },
});

export const { setLoading, setSignupData, setError } = signUp.actions;
export default signUp.reducer;

export const appSignUp = (data, callback) => async (dispatch) => {
  let response;
  try {
    dispatch(setLoading({ loading: true }));
    dispatch(setSignupData({ signUpData: "" }));
    dispatch(setError({ signUpError: "" }));

    response = await post(POST_SIGN_UP, data);
    if (response) {
      if (response.error) {
        dispatch(
          setError({
            signUpError: response.error,
          })
        );
      } else {
        if (callback) callback();
        dispatch(setSignupData({ signUpData: response?.data }));
      }
    }
    dispatch(setLoading({ loading: false }));
  } catch (error) {
    if (error)
      dispatch(
        setError({
          signUpError: error,
        })
      );
    dispatch(setLoading({ loading: false }));
  }
};

export const resendOTP = (data, callback) => async (dispatch) => {
  let response;
  try {
    dispatch(setLoading({ loading: true }));
    dispatch(setError({ signUpError: "" }));

    response = await patch(POST_RESEND_OTP, data);
    if (response) {
      if (response.error)
        dispatch(
          setError({
            signUpError: response.error,
          })
        );
      else if (callback) callback();
    }
    dispatch(setLoading({ loading: false }));
  } catch (error) {
    if (error)
      dispatch(
        setError({
          signUpError: error,
        })
      );

    dispatch(setLoading({ loading: false }));
  }
};

export const clearSignUpData = () => async (dispatch) => {
  dispatch(setSignupData({ signUpData: {} }));
};
